import { useAuthContext } from 'contexts';
import moment from 'moment';
import { useState } from 'react';
import { fhirGet } from 'services';
import useSWR from 'swr';
import type { SWRConfiguration } from 'swr';
import type { CommunicationData } from 'types';
import { defaultSWROptions } from 'utils';

export const useGetTransferLineCommunications = () => {
  const { token } = useAuthContext();
  const [communicationsData, setCommunicationsData] = useState<CommunicationData>();

  const query = [
    'identifier=https://projectwell.io/fhir/identifiers/communication/extension-line|true',
    'identifier:not=https://projectwell.io/fhir/identifiers/communication/contact-state|deleted',
    'medium=zoom', //use medium codes
  ].join('&');

  const url = `/Communication/?${query}`;

  const swrOptions: SWRConfiguration = {
    //refreshInterval: 60000, //turned off per ruth's request 2025
    ...defaultSWROptions,
  };

  const {
    //data: communicationsData,
    error: communicationsError,
    isValidating: isLoading,
    mutate: communicationsMutate,
    // `fhirGet` resolves `CommunicationData | undefined` when the key is not ready,
    // while swr 0.5.7's fetcher parameter declares no `undefined`.
  } = useSWR<CommunicationData, Error>([url, token], fhirGet as () => Promise<CommunicationData>, {
    ...swrOptions,
    onSuccess: (data) => {
      if (data?.entry?.length > 0) {
        const newDataEntry = data.entry
          .filter(c => c.resource?.subject === undefined) // filter out comms assigned to a member
          .sort((a, b) => {
            const dateA = moment(a.resource?.sent || a.resource?.received);
            const dateB = moment(b.resource?.sent || b.resource?.received);
            return dateB.valueOf() - dateA.valueOf();
          });
        data.entry = newDataEntry
      }
      setCommunicationsData(data)
    },
  });

  return {
    communicationsData,
    communicationsError,
    communicationsMutate,
    isLoading,
  };
};
